const normalizarNumeroPergunta = (numero) => String(numero ?? "");

export function limparAprovacaoAutomaticaRespostaNegativa(item) {
  if (item && item.resposta === false && item.aprovacaoAutomaticaSemEvidencia) {
    item.evidenciada = false;
    item.aprovada = false;
    item.rejeitada = false;
    item.resposta2 = null;
    item.pontos_especificos = 0;
  }
}

export function obterPerguntasCondicionais(
  regrasCondicionais = [],
  perguntaPrincipal
) {
  const perguntaInicial = normalizarNumeroPergunta(perguntaPrincipal);
  const pendentes = [perguntaInicial];
  const visitadas = new Set([perguntaInicial]);
  const condicionais = [];

  while (pendentes.length) {
    const principalAtual = pendentes.shift();

    regrasCondicionais.forEach((regra) => {
      if (
        normalizarNumeroPergunta(regra.perguntaPrincipal) !== principalAtual
      ) {
        return;
      }

      const condicional = normalizarNumeroPergunta(
        regra.perguntaCondicional
      );

      if (!condicional || visitadas.has(condicional)) {
        return;
      }

      visitadas.add(condicional);
      condicionais.push(condicional);
      pendentes.push(condicional);
    });
  }

  return condicionais;
}

export function aplicarNaoNasPerguntasCondicionais(
  perguntas = [],
  regrasCondicionais = [],
  perguntaPrincipal
) {
  const condicionais = new Set(
    obterPerguntasCondicionais(regrasCondicionais, perguntaPrincipal)
  );

  perguntas.forEach((item) => {
    if (
      item &&
      item.pergunta &&
      condicionais.has(normalizarNumeroPergunta(item.pergunta.numero))
    ) {
      item.resposta = false;
      item.respondida = true;
      limparAprovacaoAutomaticaRespostaNegativa(item);
    }
  });

  return perguntas;
}
